/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DiagramFactorLocationType } from './diagramFactorLocationType';


/**
 * Project diagram link
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProjectDiagramLink { 
    /**
     * Miradi object resource identifier
     */
    resourceIdentifier?: string;
    /**
     * Miradi formatted_text fields (allows limited html markup)
     */
    annotation?: string;
    /**
     * Miradi object resource identifier
     */
    fromDiagramFactor?: string;
    /**
     * Miradi object resource identifier
     */
    toDiagramFactor?: string;
    /**
     * Diagram link bend points
     */
    bendPoints?: Array<DiagramFactorLocationType>;
    /**
     * Diagram link is bidirectional
     */
    isBidirectional?: boolean;
    /**
     * Diagram link is uncertain
     */
    isUncertain?: boolean;
    /**
     * Diagram link color
     */
    linkColor?: string;
    /**
     * Diagram link z-index
     */
    zIndex?: number;

    constructor(item?: Partial<ProjectDiagramLink>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            resourceIdentifier: {
                type: 'uuid',
                minLength: 36,
                maxLength: 36,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.resourceIdentifier : itemOrValue;

                    if (itemOrValue?.resourceIdentifier != null) {
                        if (itemOrValue.resourceIdentifier === '') {
                            itemOrValue.resourceIdentifier = undefined;
                        } else if (['int32', 'int64'].indexOf('uuid') >= 0) {
                            itemOrValue.resourceIdentifier = parseInt(itemOrValue.resourceIdentifier.toString(), 10);
                        } else if (['float'].indexOf('uuid') >= 0) {
                            itemOrValue.resourceIdentifier = parseFloat(itemOrValue.resourceIdentifier.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'uuid');
                    if (['uuid'].indexOf('uuid') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, 36, 36);
                    }

                    return result;
                }
            },
            annotation: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.annotation : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            fromDiagramFactor: {
                type: 'uuid',
                minLength: 36,
                maxLength: 36,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.fromDiagramFactor : itemOrValue;

                    if (itemOrValue?.fromDiagramFactor != null) {
                        if (itemOrValue.fromDiagramFactor === '') {
                            itemOrValue.fromDiagramFactor = undefined;
                        } else if (['int32', 'int64'].indexOf('uuid') >= 0) {
                            itemOrValue.fromDiagramFactor = parseInt(itemOrValue.fromDiagramFactor.toString(), 10);
                        } else if (['float'].indexOf('uuid') >= 0) {
                            itemOrValue.fromDiagramFactor = parseFloat(itemOrValue.fromDiagramFactor.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'uuid');
                    if (['uuid'].indexOf('uuid') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, 36, 36);
                    }

                    return result;
                }
            },
            toDiagramFactor: {
                type: 'uuid',
                minLength: 36,
                maxLength: 36,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.toDiagramFactor : itemOrValue;

                    if (itemOrValue?.toDiagramFactor != null) {
                        if (itemOrValue.toDiagramFactor === '') {
                            itemOrValue.toDiagramFactor = undefined;
                        } else if (['int32', 'int64'].indexOf('uuid') >= 0) {
                            itemOrValue.toDiagramFactor = parseInt(itemOrValue.toDiagramFactor.toString(), 10);
                        } else if (['float'].indexOf('uuid') >= 0) {
                            itemOrValue.toDiagramFactor = parseFloat(itemOrValue.toDiagramFactor.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'uuid');
                    if (['uuid'].indexOf('uuid') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, 36, 36);
                    }

                    return result;
                }
            },
            bendPoints: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.bendPoints : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isBidirectional: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.isBidirectional : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isUncertain: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.isUncertain : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            linkColor: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.linkColor : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            zIndex: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.zIndex : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProjectDiagramLink.isValid,
        };
    }

    static isValid(obj: ProjectDiagramLink): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProjectDiagramLink.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.resourceIdentifier.isValid(item);
            result = result && validationObject.annotation.isValid(item);
            result = result && validationObject.fromDiagramFactor.isValid(item);
            result = result && validationObject.toDiagramFactor.isValid(item);
            result = result && validationObject.bendPoints.isValid(item);
            result = result && validationObject.isBidirectional.isValid(item);
            result = result && validationObject.isUncertain.isValid(item);
            result = result && validationObject.linkColor.isValid(item);
            result = result && validationObject.zIndex.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

